import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../context/ToastContext";

const INACTIVITY_LIMIT = 60 * 60 * 1000;

export default function useAutoLogout(isAuthenticated) {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const timerRef = useRef(null);

  const logout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("lastActivity");
    showToast("Session expired. Logged out due to inactivity ⏰", "warning");
    navigate("/", { replace: true });
  };

  const resetTimer = () => {
    if (!isAuthenticated) return;

    localStorage.setItem("lastActivity", Date.now());

    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(logout, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    if (!isAuthenticated) return;

    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer(); 

    return () => {
      events.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [isAuthenticated]);
}
